import { createSelector } from "reselect";
import { selectIsForwardingPlan } from "./selectIsForwardingPlan";
import { selectLoadedShipmentWarehouseId } from "../shipments/selectLoadedShipmentWarehouseId";
import { HUB_LOCATIONS } from "inbounds/ShipmentDetails/Milestones/constants/HubConstants";
import { RootState } from "RootReducer";
import { selectIsMultiNodeZBPFlow, selectIsOneNodeSupported } from "common/user/UserSelectors";

// Since prep is only supported for shipping plans with only one shipments, hence FLC prep is currently available for all Forwarding plans as well as ONE_NODE_ZBP + MULTI_NODE_ZBP merchants
export const selectIsFlcPrepAvailable: (state: RootState) => boolean = createSelector(
  selectIsForwardingPlan,
  selectIsOneNodeSupported,
  selectLoadedShipmentWarehouseId,
  selectIsMultiNodeZBPFlow,
  (isForwardingPlan, isOneNodeSupported, warehouseId, isMultiNodeZBP) =>
    isForwardingPlan || (!!isOneNodeSupported && HUB_LOCATIONS.includes(warehouseId)) || isMultiNodeZBP
);
